import React, { useState } from 'react';
import api from '../axios';

const CreateSnippet = ({ onSnippetCreated, onCancel }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [language, setLanguage] = useState('');
  const [tags, setTags] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await api.post('/api/snippets', {
        title,
        content,
        language,
        tags: tags.split(',').map((tag) => tag.trim()),
      });
      console.log('Snippet Created:', response.data);
      onSnippetCreated(response.data.snippet); // Notify parent component
    } catch (err) {
      console.error('Error creating snippet:', err);
      setError('Failed to create snippet. Please try again.');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h3>Create a New Snippet</h3>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Title:</label>
          <div>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              style={{ width: '250px', marginBottom: '10px' }}
            />
          </div>
        </div>
        <div>
          <label>Language:</label>
          <div>
            <input
              type="text"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              style={{ width: '250px', marginBottom: '10px' }}
            />
          </div>
        </div>
        <div>
          <label>Tags (comma-separated):</label>
          <div>
            <input
              type="text"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              style={{ width: '450px', marginBottom: '10px' }}
            />
          </div>
        </div>
        <div>
          <label>Content:</label>
          <div>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              required
                style={{
                  width: '650px',
                  height: '250px',
                  fontFamily: 'monospace',
                  fontSize: '12px',
                }}
            ></textarea>
          </div>
        </div>
        <div style={{ marginTop: '10px' }}>
          <button type="submit" style={{ marginRight: '10px' }}>
            Save
          </button>
          <button type="button" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateSnippet;
